import React from 'react'

const CreditCardIcon = ({ className, size = 24, color = 'currentColor' }) => {
  return (
    <svg 
      className={className}
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="card-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(100, 150, 255, 1)" />
          <stop offset="100%" stopColor="rgba(150, 100, 255, 1)" />
        </linearGradient>
        <filter id="card-glow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      <rect 
        x="2" 
        y="5" 
        width="20" 
        height="14" 
        rx="2" 
        stroke="url(#card-gradient)" 
        strokeWidth="2"
        filter="url(#card-glow)"
      />
      <path 
        d="M2 10H22M6 15H10M14 15H15" 
        stroke="url(#card-gradient)" 
        strokeWidth="2" 
        strokeLinecap="round"
        filter="url(#card-glow)"
      />
      <circle cx="18" cy="8" r="1" fill="url(#card-gradient)" opacity="0.7" />
      <circle cx="20" cy="8" r="1" fill="url(#card-gradient)" opacity="0.5" />
    </svg>
  )
}

export default CreditCardIcon
